import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Icon from 'components/AppIcon';

const AdminHeader = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/admin/login');
  };

  return (
    <header className="bg-surface border-b border-border shadow-elevation-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Title */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Shield" size={20} className="text-white" />
            </div>
            <div>
              <h1 className="text-lg font-heading-bold text-text-primary">
                Admin Panel
              </h1>
              <p className="text-xs text-text-tertiary">
                FiberFlow Configuration
              </p>
            </div>
          </div>

          {/* User Info & Actions */}
          <div className="flex items-center space-x-4">
            {/* User Email */}
            <div className="hidden sm:flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="User" size={16} />
              <span>{user?.email}</span>
            </div>

            {/* Back to Calculator */}
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center px-3 py-2 text-sm text-text-secondary hover:text-primary hover:bg-primary-50 rounded-lg transition-all duration-150"
            >
              <Icon name="Home" size={16} className="mr-1.5" />
              <span className="hidden sm:inline">Calculator</span>
            </button>

            {/* Sign Out */}
            <button
              onClick={handleSignOut}
              className="inline-flex items-center px-3 py-2 text-sm text-error hover:bg-error-50 rounded-lg transition-all duration-150 font-body-medium"
            >
              <Icon name="LogOut" size={16} className="mr-1.5" />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
